var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#9581B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 28.875V27.125C28 26.1967 27.6312 25.3065 26.9749 24.6501C26.3185 23.9937 25.4283 23.625 24.5 23.625H17.5C16.5717 23.625 15.6815 23.9937 15.0251 24.6501C14.3687 25.3065 14 26.1967 14 27.125V28.875M24.5 16.625C24.5 18.558 22.933 20.125 21 20.125C19.067 20.125 17.5 18.558 17.5 16.625C17.5 14.692 19.067 13.125 21 13.125C22.933 13.125 24.5 14.692 24.5 16.625Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1674a3263a61cab2153a857d6145777b.svg";
export { ForwardRef as ReactComponent };